module.exports = __webpack_public_path__ + "img/notes.ab85a586.svg";